import index from '../pages/index.vue'
import chosefood from '../pages/chosefood.vue'
import chosemotion from '../pages/chosemotion.vue'
import result from '../pages/result.vue'

import sugarIndex from '../blood_sugar/sugarindex.vue'
import sugarFood from '../blood_sugar/selectfood.vue'
import sugarGis from '../blood_sugar/gis.vue'

import needIndex from '../dayneed/dayneedindex.vue'
import fillform from '../dayneed/fillform.vue'
import dayneedresult from '../dayneed/dayneedresult.vue'

import carboindex from '../carbohydrate/carboindex.vue'
import carbofood from '../carbohydrate/carbofood.vue'
import carbofood1 from '../carbohydrate/carbofood1.vue'
import carboresult from '../carbohydrate/carboresult.vue'
import carboresult1 from '../carbohydrate/carboresult1.vue'
import carbofinal from '../carbohydrate/carbofinal.vue'

export default [
	{
		path:'/index',
		component:index,
		name:'index'
	},
	{
	    path: '/',
	    component:index
	},
	{
	    path: '/chosefood',
	    component:chosefood
	},
	{
	    path: '/chosemotion',
	    component:chosemotion
	},
	{
	    path: '/result',
	    component:result
	},
	{
	    path: '/sugarindex',
	    component:sugarIndex
	},
	{
	    path: '/sugarfood',
	    component:sugarFood
	},
	{
	    path: '/gis',
	    component:sugarGis
	},
	{
	    path: '/dayneedindex',
	    component:needIndex
	},
	{
	    path: '/fillform',
	    component:fillform
	},
	{
	    path: '/dayneedresult',
	    component:dayneedresult
	},
	{
	    path: '/carboindex',
	    component:carboindex
	},
	{
	    path: '/carbofood',
	    component:carbofood
	},
	{
	    path: '/carbofood1',
	    component:carbofood1
	},
	{
	    path: '/carboresult',
	    component:carboresult
	},
	{
	    path: '/carboresult1',
	    component:carboresult1
	},
	{
	    path: '/carbofinal',
	    component:carbofinal
	}
]


// WEBPACK FOOTER //
// ./src/router/config.js